var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDebugging = function SvgDebugging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#debugging_svg__a)",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 75.5c20.71 0 37.5-16.79 37.5-37.5S60.71.5 40 .5 2.5 17.29 2.5 38 19.29 75.5 40 75.5ZM40 63c13.807 0 25-11.193 25-25S53.807 13 40 13 15 24.193 15 38s11.193 25 25 25Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19 80.5H19.387c-3.914 0-6.31-4.293-4.256-7.624l21.402-34.707c1.953-3.167 6.558-3.167 8.512 0l21.401 34.707c2.054 3.33-.342 7.624-4.256 7.624Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "debugging_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z",
    transform: "translate(0 .5)"
  })))));
};
export default SvgDebugging;